import React from "react";
import UserList from "../Table/UserList";

const SeoList = () => {
  return <UserList userRole={5} userType={"seo"} />;
};

export default SeoList;
